module.exports = __webpack_public_path__ + "img/azxy5_icon.9fa1308f.png";